/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import RealEstateAgentReferralRepository from 'repositories/buyer/RealEstateAgentReferralRepository';

const initialState = {
  realEstateAgentReferralSettingsStatus: FETCH_STATUSES.idle,
};

const buyerSlice = createSlice({
  name: 'buyerSlice',
  initialState,
  reducers: {
    setRealEstateAgentReferralStart(state) {
      state.realEstateAgentReferralSettingsStatus = FETCH_STATUSES.pending;
    },
    setRealEstateAgentReferralSuccess(state) {
      state.realEstateAgentReferralSettingsStatus = FETCH_STATUSES.fulfilled;
    },
    setRealEstateAgentReferralFail(state) {
      state.realEstateAgentReferralSettingsStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = buyerSlice;

export default buyerSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const setRealEstateAgentReferral = async slug => {
    dispatch(actions.setRealEstateAgentReferralStart());
    try {
      await RealEstateAgentReferralRepository.create(slug, {});
      dispatch(actions.setRealEstateAgentReferralSuccess());
    } finally {
      dispatch(actions.setRealEstateAgentReferralFail());
    }
  };

  return {
    setRealEstateAgentReferral,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/slices/buyerSlice.js